<h2>Locatie</h2>
<div class="flex-row field-input">
  <label>Rek</label>
  <mat-form-field appearance="outline">
    <input matInput [(ngModel)]="location.rack" required />
  </mat-form-field>
</div>
<div class="flex-row field-input">
  <label>Schap</label>
  <mat-form-field appearance="outline">
    <input matInput [(ngModel)]="location.shelf" required />
  </mat-form-field>
</div>
<div class="flex-row field-input">
  <label>Vaknummer</label>
  <mat-form-field appearance="outline">
    <input type="number" matInput [(ngModel)]="location.compartment" required />
  </mat-form-field>
</div>

<div class="confirm-container border-top">
  <button class="btn button" type="button" (click)="save()">
    <span>Opslaan</span>
  </button>
</div>
